import React from "react";
import Link from "@/components/link"
import ProductsDetails from "../../../data/data.json";
import { withPrefix } from "gatsby";

const PartitionProducts = () => {
  const { subProducts } = ProductsDetails["partition"];

  return (
    <div className="container my-5">
      <div className="row">
        {subProducts.map((product) => (
          <div className="col-md-4 mb-4" key={product.slug}>
            <Link
              href={`/products/partition/${product.slug}`}
              className="modularKitchenCard"
            >
              <div className="imageCardContainer">
                <img
                  src={withPrefix(product.image)}
                  className="card-img-top cardProductImage"
                  alt={product.number}
                />
              </div>
              <div className="card-body">
                <h5 className="card-title">{product.number}</h5>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PartitionProducts;
